import React from 'react'
import { Layout } from './Layout'
import { useProps, Params } from './useProps'
import { RequiredAuthProvider } from '../../providers/RequiredAuthProvider'

type Props = Params

const Page = (props: Props) => <Layout {...useProps(props)} />

export const ArcadeMachineSearchPage = (props: Props) => (
  <RequiredAuthProvider>
    <Page {...props} />
  </RequiredAuthProvider>
)
